// extracted by css-extract-rspack-plugin
export default {"navTabItem":"_ceee45ab","navTabLink":"_fc83027e","active":"_6bc750fc","panels":"_c5e7e815","wrapper":"_556e3063","innerPanel":"_f5fd7898","storyTellingWrapper":"_2bc31"};